
  export default {
    name: 'CourseCard',
    props: {
      img: {
        default: '',
        type: String,
      },
      header: {
        default: '',
        type: String,
      },
      season: {
        default: '',
        type: String,
      },
      episode: {
        default: '',
        type: String,
      },
      url: {
        default: '',
        type: String,
      },
      text: {
        default: '',
        type: String,
      },
    },
    methods: {
      cardImage(thumbnail) {
        // console.log('THUMBNAIL',thumbnail)
        const imgUrl = this.$img(this.$options.filters.cdn(thumbnail), { format:'webp',quality:50, width:'600px' })
        return {
          backgroundImage: `url('${imgUrl}')`
        }
      },
    }
  }
  